module.exports = __webpack_public_path__ + "static/media/254820HD_v2_Botox_AssignedEd.4d9b6c78.mp4";